import React, { Component } from "react";
import { Button, Modal } from "semantic-ui-react";
import "react-html5-camera-photo/build/css/index.css";
import { connect } from "react-redux";
import { isTabletOrLess } from "utils/isMobile";
import debounce from "lodash.debounce";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "components/Form/Select";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";

// const styles = {
// 	borderedCard: {

// 	},
// 	scanInput: {

// 	},
// 	subtitle: {

// 	},
// 	centered: {
// 		display: 'flex',
// 		justifyContent: 'center',
// 	},

// 	centeredInput: {
// 		minWidth: '50px',
// 		width: '100%'
// 	},
// };

const schemaValidation = Yup.object().shape({
	documentType: Yup.number().nullable().required("Champs requis"),
	scannedBarCode: Yup.string(),
});

class QRScanCodeBarreOrdonance extends Component {
	constructor(props) {
		super(props);

		this.state = {
			scannerReady: false,
			alternativeScannerValue: "",
			docType: 1,
		};
	}

	sendData = (scannedBarCode, documentType) => {
		this.props.close();
		this.props.submit(scannedBarCode, documentType);
	};

	submitAlternativeScanner = debounce(this.sendData, 700);

	handleKeyDown = (event, values) => {
		return (
			event.key === "Enter" &&
			values.scannedBarCode &&
			values.scannedBarCode.length === 10 &&
			values.scannedBarCode.match("^[0-9]{10}$") &&
			values.scannedBarCode.match("^[0-9]{10}$").length > 0
		);
	};

	render() {
		const { open, documentTypeOptions, defaultDocumentTypeValue } = this.props;
		let documentTypeOptionsSorted = documentTypeOptions
			.slice()
			.filter((d) => d.order < 3)
			.sort((d1, d2) => d1.order - d2.order);
		return (
			<div>
				<Formik
					initialValues={{
						documentType: defaultDocumentTypeValue,
						scannedBarCode: "",
					}}
					validationSchema={schemaValidation}
					isInitialValid={defaultDocumentTypeValue !== null && defaultDocumentTypeValue !== undefined}
					onSubmit={(values) => {
						this.sendData(values.scannedBarCode, values.documentType);
						this.props.close();
					}}
				>
					{({ values, submitForm }) => {
						return (
							<Form>
								<Modal
									size={isTabletOrLess ? "small" : "large"}
									open={open}
									closeOnEscape={true}
									closeOnDimmerClick={true}
									onClose={this.props.close}
								>
									<Modal.Header>Scanner le code-barres document et sélectionner son type</Modal.Header>
									<Modal.Content style={{ textAlign: "center", margin: "auto" }}>
										<div style={{ margin: "0 25%" }}>
											<Field
												autoFocus
												component={CustomInputTextComponent}
												name="scannedBarCode"
												customlabel="Code-barres"
												placeholder="12345678910"
												onKeyDown={(e) => {
													if (this.handleKeyDown(e, values)) submitForm(values);
												}}
												required
											/>
										</div>
										<div style={{ margin: "0 25%" }}>
											{documentTypeOptionsSorted && (
												<Field
													style={{ width: "50%" }}
													component={Select}
													name="documentType"
													customlabel="Type de document"
													placeholder="Sélectionner un type de document"
													options={documentTypeOptionsSorted.map((option) => {
														return {
															value: option.id,
															label: option.title,
														};
													})}
													required
												/>
											)}
										</div>
									</Modal.Content>
									<Modal.Actions>
										<Button
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												this.props.close();
											}}
										>
											Annuler
										</Button>
										<Button
											onClick={() => submitForm(values)}
											primary
											disabled={!values.scannedBarCode.match("^[0-9]{10}$") || values.scannedBarCode.match("^[0-9]{10}$").length === 0}
										>
											Confirmer
										</Button>
									</Modal.Actions>
								</Modal>
							</Form>
						);
					}}
				</Formik>
			</div>
		);
	}
}

export default connect(null, null)(QRScanCodeBarreOrdonance);
